import { useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Contemplados from '../contemplados'
import DIALOGSORTEADODETALHE from 'dialog/dialogsorteadodetalhe';
import { Link } from 'react-router-dom';


const CarrosselContemplados = ({ lcontemplado }) => {
  const [pppdetalhe, setPPPDetalhe] = useState(false);
  const [contemplado, setContemplado] = useState({}); 

  function mostraDetalhe(d) {
    setContemplado(d);
    setPPPDetalhe(true);
  }
  
  const responsive = {
    superLargeDesktop: {
      // screens larger than 1920px
      breakpoint: { max: 4000, min: 1920 },
      items: 4
    },
    desktop: {
      // screens larger than 1024px
      breakpoint: { max: 1920, min: 1024 },
      items: 3
    },
    tablet: {
      // screens larger than 464px
      breakpoint: { max: 1024, min: 768 },
      items: 2
    },
    mobile: {
      // screens smaller than 464px
      breakpoint: { max: 768, min: 0 },
      items: 1
    }
  };

  return (
    <>
      {lcontemplado.length > 0 && (
        <div className='mt-4'>
          <div className='d-flex align-items-center justify-content-between mb-3 px-2'>
            <h2 className='section-title mb-0'>Ganhadores & Sorteados</h2>
            <Link to="/meu/sorteados" className="btn btn-primary btn-sm rounded-pill">
              <i className="fas fa-search me-1"></i> Ver todos
            </Link>
          </div>
          <div className='modern-carousel'>
            <Carousel 
              responsive={responsive} 
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={5000}
              arrows={true}
              showDots={false}
            >
              {lcontemplado.map((d, index) => (
                <div key={`contem${index}`} className="p-2" onClick={() => mostraDetalhe(d)}>
                  <Contemplados
                   banner={d.banner}
                   nome={d.nome}
                   nome_sorteado={d.nome_sorteado}
                   nome_estabelecimento={d.nom_estabelecimento}
                   datasorteio={d.data_sorteio}
                   limages={d.images}
                  />
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      )}
      <DIALOGSORTEADODETALHE
        trigger={pppdetalhe}
        setTrigger={setPPPDetalhe}
        contemplado={contemplado}
        />
    </>
  );
};

export default CarrosselContemplados;
